<form [formGroup]="form" class="contact-form" (ngSubmit)="onSubmit()">
  <label class="form-input-wrapper">
    <span class="form-input-label">Fax number:</span>
    <input formControlName="faxNumber" placeholder="+18121112233" class="form-input_md" />
  </label>

  <label class="form-input-wrapper">
    <span class="form-input-label">Name:</span>
    <input formControlName="name" placeholder="Name Surname" class="form-input_md" />
  </label>

  <label class="form-input-wrapper">
    <span class="form-input-label">Email:</span>
    <input formControlName="email" type="email" placeholder="mail@mail.com" class="form-input_md" />
  </label>

  <button type="submit" [disabled]="form.invalid" class="btn_primary btn_lg">Save</button>
</form>
